// Vendors
import { push } from 'connected-react-router';

// requests
import { lookupAppLinkRequest } from '../../../backend/agencyRequests';
import { userVerifyAddressRequest } from '../../../backend/userRequests';

import {
  checkRequestFailure,
  handleRequestFailure,
  ERRORS_MAP,
} from '../../../lib/validation';

//actions
import { APP_TRANSACTION_IDS, clearAppData, storeBasicInfo } from '../../app/appActions';
import { openModal } from '../../modal/modalActions';
//helpers
import { 
  to,
  cloneObject,
  formatAddressFromForm
} from '../../../lib/helpers';

//constants
export const TXHHS_TXHHSCHIP_CLEAR_DATA = '[TXHHS] TXHHS_CHIP - Clear Data';
export const TXHHS_MANAGE_SERVICE_ACTION = '[TXHHS] Manage Service Action';
export const TXHHS_SET_STEPS_CONFIG = '[TXHHS] Set Steps Config';
export const TXHHS_STORE_DETAILED_LOOKUP = '[TXHHS] Store Detailed Lookup';
export const TXHHS_UPDATE_PAYMENT_WAS_MADE = '[TXHHS] Update Payment Was Made';

// DataCollection page action constants
export const TXHHS_STORE_VEHICLEDETAILS_DATA = '[TXHHS] Store VehicleDetails Data';
export const TXHHS_STORE_CONTACTDETAILS_DATA = '[TXHHS] Store ContactDetails Data';
export const TXHHS_STORE_ADDITIONALINFO_DATA = '[TXHHS] Store AdditionalInfo Data';

// Address verification constants
export const TXHHS_MELISA_SUCCESS = 'SUCCESS';
export const TXHHS_MELISA_CONTINUE = 'CONTINUE';
export const TXHHS_MELISA_WARNING = 'WARNING';
export const TXHHS_MELISA_ERROR = 'ERROR';
export const TXHHS_MELISA_ADDRESS_TWO_MISSING = 'ADDRESS_TWO_MISSING';
export const TXHHS_MELISA_ADDRESS_TWO_INVALID = 'ADDRESS_TWO_INVALID';
export const TXHHS_MELISA_ADDRESS_NOT_VERIFIED = 'ADDRESS_NOT_VERIFIED';
export const TXHHS_MELISA_INVALID_ADDRESS = 'INVALID_ADDRESS';

export function storeSelected(data) {
  return {
    type: TXHHS_MANAGE_SERVICE_ACTION,
    payload: data,
  };
}

export function storeVehicleDetailsData(data) {
  return {
    type: TXHHS_STORE_VEHICLEDETAILS_DATA,
    payload: data,
  };
}

export function storeContactDetailsData(data) {
  return {
    type: TXHHS_STORE_CONTACTDETAILS_DATA,
    payload: data,
  };
}

export function storeAdditionalInfoData(data) {
  return {
    type: TXHHS_STORE_ADDITIONALINFO_DATA,
    payload: data,
  };
}


export const manageTXHHSServiceAction = (data) => async dispatch => {
  await dispatch(storeBasicInfo(data));
  await dispatch(storeSelected(data));
  return dispatch(getTXHHSDetailedLookup());
};

export const clearTXHHSData = () => dispatch => {
  dispatch(clearAppData());
  return dispatch({ type: TXHHS_TXHHSCHIP_CLEAR_DATA });
};

export const setStepsConfig = (stepsConfig) => ({
  type: TXHHS_SET_STEPS_CONFIG,
  payload: stepsConfig,
});

// Address verification
export const verifyTXHHSMailingAddress = ({ values, formikActions }) => {
  return async dispatch => {
    const formValues = cloneObject(values);
    formValues.address = formatAddressFromForm(formValues.mailingAddress || formValues);

    const [{ body, response }, err] = await to(
      dispatch(userVerifyAddressRequest(formValues.address))
    );

    if (checkRequestFailure({ response, body }))
      return handleRequestFailure(body, formikActions, ERRORS_MAP.ADDRESS);

    if (err) return Promise.reject(err);

    formikActions.setSubmitting(false);

    if (checkRequestFailure({ body, response })) {
      handleRequestFailure(body, formikActions, ERRORS_MAP.ADDRESS);
      return Promise.reject();
    }

    // A modified address was found...prompt user which to use
    if (body.status === TXHHS_MELISA_CONTINUE) {
      dispatch(
        openModal('VerifyAddressModal/TXHHS', {
          enteredAddress: formValues.address,
          addressOptions: body.data,
        })
      );
    }

    // Action may be needed from user
    if (
      body.status === TXHHS_MELISA_WARNING ||
      body.status === TXHHS_MELISA_ERROR
    ) {
      switch (body.message) {
        case TXHHS_MELISA_ADDRESS_TWO_MISSING:
          dispatch(
            openModal('AddressTwoMissingModal/TXHHS', {
              enteredAddress: formValues.address,
              addressOptions: body.data,
            })
          );
          break;
        case TXHHS_MELISA_ADDRESS_TWO_INVALID:
          dispatch(
            openModal('AddressTwoIncorrectModal/TXHHS', {
              enteredAddress: formValues.address,
              addressOptions: body.data,
            })
          );
          break;
        case TXHHS_MELISA_ADDRESS_NOT_VERIFIED:
        case TXHHS_MELISA_INVALID_ADDRESS:
          dispatch(
            openModal('AddressCantConfirm/TXHHS', {
              enteredAddress: formValues.address,
            })
          );
          break;
        default:
          break;
      }
    }

    return Promise.resolve(body);
  };
};

export function getTXHHSDetailedLookup(
  transactionId = 'DETAILEDLOOKUP'
) {
  return async function(dispatch, getStore) {
    const store = getStore();
    const txhhs = store.txhhs.selected;
    const { userKey, appId, link } = txhhs;
    const account = link?.profile?.account?.[0] || {};

    const requestBody = {
      appId,
      userKeys: [userKey],
      transactionId,
      transactionInfo: account,
    };

    const [{ body }, err] = await to(dispatch(lookupAppLinkRequest(requestBody)));

    if (body && body.status === 'SUCCESS' && body.data) {
      dispatch(storeDetailedLookup(body.data));
      return dispatch(push('/txhhschip'));
    }
    if (body.errors) return Promise.resolve(body);
    if (err) return Promise.reject(err);
  };
}

export function storeDetailedLookup(data) {
  return {
    type: TXHHS_STORE_DETAILED_LOOKUP,
    payload: data,
  };
}

export function getLookUpDataAndRenewTXHHS({ appId, userKeys, transactionId }) {
  return async function(dispatch) {
    const requestBody = {
      appId,
      userKeys,
      transactionId,
    };
    const [{ body = {} }, err] = await to(
      dispatch(lookupAppLinkRequest(requestBody))
    );
    if (body.data && body.data.profiles && body.data.profiles.length > 0) {
      dispatch(
        manageTXHHSServiceAction({
          link: { profile: (body.data || {}).profiles[0] },
          userKey: ((body.data || {}).profiles[0] || {}).userKey,
          appId,
          agencyId: '50',
        })
      );
    }
    if (err) return Promise.reject(err);
    return Promise.resolve(body.data);
  };
}

export const formatTXHHSPayment = translate => {
  return async function(dispatch, getStore) {
    const { txhhs, user } = getStore();
    const { profile: contDetails = {} } = user;
    const {
      additionalInfoData,
      vehicleDetailsData,
      contactDetailsData,
      detailedLookup = {},
    } = txhhs;
    const {
      userKey,
      appId,
      agencyId,
      link: { profile: { account = {} } = {} },
    } = txhhs.selected;
    const [accountDetails] = account;  
    const userKeys = [userKey];
    const paymentDetails = detailedLookup.paymentDetails;
    const mailingAddress = additionalInfoData?.mailingAddress || {};
    const contactDetails = {
      firstName: mailingAddress.firstName,
      middleName: '',
      lastName: mailingAddress.lastName,
      suffix: '',
      entity: '',
      email: contDetails.userEmail,
      phone: contDetails.phoneNum,
      mailingAddress: {
        address1: mailingAddress.streetAddress
          ? mailingAddress.streetAddress
          : null,
        address2: mailingAddress.addressLine2
          ? mailingAddress.addressLine2
          : null,
        city: mailingAddress.city
          ? mailingAddress.city
          : null,
        postalCode: (mailingAddress.zipFive || '') + (mailingAddress.zipFour ? '-' + mailingAddress.zipFour : ''),
        stateProvince: mailingAddress.state?.value || null,
      },
    };
       
    // Merge all data collection page data, excluding mailing address fields
    const { mailingAddress: _, ...collectedData } = {
      ...(vehicleDetailsData || {}),
      ...(contactDetailsData || {}),
      ...(additionalInfoData || {}),
    };
    
    const renewalFee = paymentDetails
      .filter(fee => fee.paymentDescription == 'Transaction Fee')
      .reduce((accumulator, currentValue) => {
        return accumulator + currentValue.amount;
      }, 0);
    //create the final transaction object
    const transactionInfo = {
      contactDetails: contactDetails,
      ...collectedData,
      transactionAmounts: {
        renewalFee: parseFloat(renewalFee || 0).toFixed(2),
        paymentDetails,
        subTotal: detailedLookup.subTotal,
        paymentDetailsSignature: detailedLookup.paymentDetailsSignature
      },
    };
    return {
      userKeys,
      appId,
      agencyId,
      transactionId: APP_TRANSACTION_IDS.SUBMIT_CREATE_PAYMENT,
      transactionInfo,
    };
  };
};

export const updatePaymentWasMade = (status = false) => {
  return {
    type: TXHHS_UPDATE_PAYMENT_WAS_MADE,
    status: status,
  };
};
